




























































































import { Component, Watch, Vue } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import * as M from "materialize-css";
const user = namespace("User");
@Component
export default class Login extends Vue {
  @Validate({ required, email })
  email = "";
  @Validate({ required })
  password = "";
  fromRoute = "/";
  errors: string[] = [];

  @user.State
  public loggedIn!: boolean;

  mounted() {
    if (this.$route.query.redirect) {
      this.fromRoute = this.$route.query.redirect + "";
    }
    if (this.loggedIn) {
      this.$router.replace(this.fromRoute);
    } else {
      let ui = firebaseui.auth.AuthUI.getInstance();
      if (!ui) {
        const auth = firebase.auth();
        ui = new firebaseui.auth.AuthUI(auth);
      }
      const uiConfig = {
        signInSuccessUrl: this.fromRoute,
        signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
        tosUrl: "https://evoluq.com",
        // Privacy policy url.
        privacyPolicyUrl: "https://evoluq.com/policy"
      };
      ui.start("#firebaseui-auth-container", uiConfig);
      /*
      this.$auth.initUi(this.fromRoute).then( result => {
        console.log("INIT-UI:" + result);
      });
      */
    }
    this.$nextTick(M.updateTextFields);
  }

  @Watch("loggedIn")
  loggedInChanged(newVal: boolean) {
    if (newVal) {
      this.$router.replace(this.fromRoute);
    }
  }

  public login(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.errors = [];
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            console.log("LOGGED: " + user);
          },
          err => {
            console.log("ERROR: " + err);
            this.errors.push(err.code);
          }
        )
        .catch(err => {
          const message: string = err.message;
          this.errors.push(message);
        });
      /*
    this.$auth.login(this.email, this.password).then(
      user => {
        console.log("LOGGED: " + user);
      },
      err => {
        console.log("ERROR: " + err);
      }
    );
    */
    }
  }
}
